/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
const Chart = require("chart.js");
//
// Chart extension for making the bars rounded
// Code from: https://codepen.io/jedtrow/full/ygRYgo
//

Chart.elements.Rectangle.prototype.draw = function () {
  var ctx = this._chart.ctx;
  var vm = this._view;
  var left, right, top, bottom, signX, signY, borderSkipped, radius;
  var borderWidth = vm.borderWidth;
  // Set Radius Here
  // If radius is large enough to cause drawing errors a max radius is imposed
  var cornerRadius = 6;

  if (!vm.horizontal) {
    // bar
    left = vm.x - vm.width / 2;
    right = vm.x + vm.width / 2;
    top = vm.y;
    bottom = vm.base;
    signX = 1;
    signY = bottom > top ? 1 : -1;
    borderSkipped = vm.borderSkipped || "bottom";
  } else {
    // horizontal bar
    left = vm.base;
    right = vm.x;
    top = vm.y - vm.height / 2;
    bottom = vm.y + vm.height / 2;
    signX = right > left ? 1 : -1;
    signY = 1;
    borderSkipped = vm.borderSkipped || "left";
  }

  // Canvas doesn't allow us to stroke inside the width so we can
  // adjust the sizes to fit if we're setting a stroke on the line
  if (borderWidth) {
    // borderWidth shold be less than bar width and bar height.
    var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
    borderWidth = borderWidth > barSize ? barSize : borderWidth;
    var halfStroke = borderWidth / 2;
    // Adjust borderWidth when bar top position is near vm.base(zero).
    var borderLeft = left + (borderSkipped !== "left" ? halfStroke * signX : 0);
    var borderRight =
      right + (borderSkipped !== "right" ? -halfStroke * signX : 0);
    var borderTop = top + (borderSkipped !== "top" ? halfStroke * signY : 0);
    var borderBottom =
      bottom + (borderSkipped !== "bottom" ? -halfStroke * signY : 0);
    // not become a vertical line?
    if (borderLeft !== borderRight) {
      top = borderTop;
      bottom = borderBottom;
    }
    // not become a horizontal line?
    if (borderTop !== borderBottom) {
      left = borderLeft;
      right = borderRight;
    }
  }

  ctx.beginPath();
  ctx.fillStyle = vm.backgroundColor;
  ctx.strokeStyle = vm.borderColor;
  ctx.lineWidth = borderWidth;

  // Corner points, from bottom-left to bottom-right clockwise
  // | 1 2 |
  // | 0 3 |
  var corners = [
    [left, bottom],
    [left, top],
    [right, top],
    [right, bottom]
  ];

  // Find first (starting) corner with fallback to 'bottom'
  var borders = ["bottom", "left", "top", "right"];
  var startCorner = borders.indexOf(borderSkipped, 0);
  if (startCorner === -1) {
    startCorner = 0;
  }

  function cornerAt(index) {
    return corners[(startCorner + index) % 4];
  }

  // Draw rectangle from 'startCorner'
  var corner = cornerAt(0);
  ctx.moveTo(corner[0], corner[1]);

  for (var i = 1; i < 4; i++) {
    corner = cornerAt(i);
    let nextCornerId = i + 1;
    if (nextCornerId === 4) {
      nextCornerId = 0;
    }

    // let nextCorner = cornerAt(nextCornerId);

    let width = corners[2][0] - corners[1][0];
    let height = corners[0][1] - corners[1][1];
    let x = corners[1][0];
    let y = corners[1][1];
    // eslint-disable-next-line
    var radius = cornerRadius;

    // Fix radius being too large
    if (radius > height / 2) {
      radius = height / 2;
    }
    if (radius > width / 2) {
      radius = width / 2;
    }

    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    ctx.lineTo(x + width, y + height - radius);
    ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
    ctx.lineTo(x + radius, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
  }

  ctx.fill();
  if (borderWidth) {
    ctx.stroke();
  }
};

var mode = "light"; //(themeMode) ? themeMode : 'light';
var fonts = {
  base: "Open Sans"
};

// Colors
var colors = {
  gray: {
    100: "#f6f9fc",
    200: "#e9ecef",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#8898aa",
    700: "#525f7f",
    800: "#32325d",
    900: "#212529"
  },
  theme: {
    default: "#172b4d",
    primary: "#5e72e4",
    secondary: "#f4f5f7",
    info: "#11cdef",
    success: "#2dce89",
    danger: "#f5365c",
    warning: "#fb6340"
  },
  black: "#12263F",
  white: "#FFFFFF",
  transparent: "transparent"
};

// Methods

// Chart.js global options
function chartOptions() {
  // Options
  var options = {
    defaults: {
      global: {
        responsive: true,
        maintainAspectRatio: false,
        defaultColor: mode === "dark" ? colors.gray[700] : colors.gray[600],
        defaultFontColor: mode === "dark" ? colors.gray[700] : colors.gray[600],
        defaultFontFamily: fonts.base,
        defaultFontSize: 13,
        layout: {
          padding: 0
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            padding: 16
          }
        },
        elements: {
          point: {
            radius: 0,
            backgroundColor: colors.theme["primary"]
          },
          line: {
            tension: 0.4,
            borderWidth: 4,
            borderColor: colors.theme["primary"],
            backgroundColor: colors.transparent,
            borderCapStyle: "rounded"
          },
          rectangle: {
            backgroundColor: "#ffcc00"//colors.theme["warning"]
          },
          arc: {
            backgroundColor: colors.theme["primary"],
            borderColor: mode === "dark" ? colors.gray[800] : colors.white,
            borderWidth: 4
          }
        },
        tooltips: {
          enabled: true,
          mode: "index",
          intersect: false
        }
      },
      doughnut: {
        cutoutPercentage: 83,
        legendCallback: function (chart) {
          var data = chart.data;
          var content = "";

          data.labels.forEach(function (label, index) {
            var bgcolors = ["#ffcc00", "black"];

            var bgColor = bgcolors[index];//data.datasets[0].backgroundColor[index];

            content += '<span class="chart-legend-item">';
            content +=
              '<i class="chart-legend-indicator" style="background-color: ' +
              bgColor +
              '"></i>';
            content += label;
            content += "</span>";
          });

          return content;
        }
      }
    }
  };

  // yAxes
  Chart.scaleService.updateScaleDefaults("linear", {
    gridLines: {
      drawOnChartArea: false,
      display: true,
      // drawBorder: true,
      // drawTicks: false,
      // lineWidth: 0,
      // zeroLineWidth: 1,
      // zeroLineColor: colors.gray[300],
    },
    ticks: {
      beginAtZero: true,
      padding: 10
      // padding: 10,
      // callback: function (value) {
      //   if (!(value % 10)) {
      //     return value;
      //   }
      // }
    }
  });

  // xAxes
  Chart.scaleService.updateScaleDefaults("category", {
    gridLines: {
      drawOnChartArea: false,
      display: true,
      // drawBorder: false,
      // drawTicks: false,
      // zeroLineWidth: 1,
      // zeroLineColor: colors.gray[300],
    },
    ticks: {
      padding: 20
    }
  });

  return options;
}

// Parse global options
function parseOptions(parent, options) {
  for (var item in options) {
    if (typeof options[item] !== "object") {
      parent[item] = options[item];
    } else {
      parseOptions(parent[item], options[item]);
    }
  }
}

// Example 1 of Chart inside src/views/Index.js (Sales value - Card)
let chartExample1 = {
  options: {
    scales: {
      yAxes: [
        {
          scaleLabel: { display: true, labelString: 'kWh' },
          ticks: {
            // callback: function (value) {
            //   if (!(value % 10)) {
            //     // return "$" + value + "k";
            //     return value;
            //   }
            // }
          },
          // maxValue: 60
        }
      ],
    },
    tooltips: {
      callbacks: {
        label: function (item, data) {
          var label = data.datasets[item.datasetIndex].label || "";
          var yLabel = item.yLabel;
          var content = "";
          if (data.datasets.length > 1) {
            content += label + ": ";
          }
          content += yLabel.toFixed(2) + " kWh";
          return content;
        }
      }
    }
  },
  data1: (canvas) => {
    return {
      labels: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
      "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
      datasets: [
        {
          label: "Production",
          data: [5, 8, 12, 22, 28, 32, 36, 38, 41, 43, 45, 47, 49, 50, 51, 50, 49, 47, 38, 25, 14, 8, 6, 5],
          borderColor: "#ffcc00",
          backgroundColor: "#ffcc00",
          fill: false
        },
        {
          label: "Consumption",
          data: [5, 10, 16, 25, 32, 36, 40, 43, 45, 46, 47, 47, 47, 46, 45, 43, 40, 36, 32, 25, 16, 10, 8, 5],
          borderColor: "black",
          backgroundColor: "black",
          fill: false
        }
      ]
    };
  },
  data2: (canvas) => {
    return {
      labels: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
      "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
      datasets: [
        {
          label: "Real",
          data: [0, 6, 12, 17, 23, 27, 31, 34, 37, 39, 41, 42, 42, null, null, null, null, null, null, null, null, null, null, null],
          borderColor: "#ffcc00",
          backgroundColor: "#ffcc00",
          fill: false
        },
        {
          label: "Estimated",
          data: [null, null, null, null, null, null, null, null, null, null, null, null, 42, 41, 39, 37, 34, 31, 27, 23, 17, 12, 6, 0],
          borderColor: "black",
          backgroundColor: "black",
          fill: false,
          borderDash: [10,5]
        }
      ]
    };
  },
  data3: (canvas) => {
    return {
      labels: ["00:00", "01:00", "02:00", "03:00", "04:00", "05:00", "06:00", "07:00", "08:00", "09:00", "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00",
      "17:00", "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"],
      datasets: [
        {
          label: "Real",
          data: [0, 10, 16, 25, 32, 36, 40, 43, 45, 46, 47, 47, 47, 46, 45, 43, 40, 36, 32, 25, 16, 10, 8, 0],
          borderColor: "#ffcc00",
          backgroundColor: "#ffcc00",
          fill: false
        },
        {
          label: "Estimated",
          data: [0, 10, 16, 25, 32, 36, 40, 43, 45, 46, 47, 47, 47, 40, 37, 39, 40, 36, 32, 25, 16, 10, 8, 0],
          borderColor: "black",
          backgroundColor: "black",
          fill: false
        }
      ]
    };
  },
  data4: (canvas) => {
    return {
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      datasets: [
        {
          label: "Real",
          data: [0, 10, 16, 25, 32, 36, 40, 43, 43, 40, 25, 0],
          borderColor: "#ffcc00",
          backgroundColor: "#ffcc00",
          fill: false
        }
      ]
    };
  },
  data5: (canvas) => {
    return {
      labels: ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
      datasets: [
        {
          label: "Real",
          data: [0, 6, 12, 17, 23, 27, 31, 34, 37, 39, 41, 42, 42, 42, 41, 39, 37, 34, 31, 27, 23, 17, 12, 6],
          borderColor: "#ffcc00",
          backgroundColor: "#ffcc00",
          fill: false
        },
      ]
    };
  },
  data6: (canvas) => {
    return {
      labels: [1,2,3,4,5,6,7,8,9,10,11,12],
      datasets: [
        {
          label: "Production",
          data: [25, 20, 30, 22, 17, 29, 25, 20, 30, 22, 17, 29],
          maxBarThickness: 10,
          backgroundColor: "#ffcc00"
        },
        {
          label: "Consumption",
          data: [15, 25, 10, 12, 15, 26, 15, 25, 10, 12, 15, 26],
          maxBarThickness: 10,
          backgroundColor: "black"
        }
      ]
    }
  }
};


module.exports = {
  chartOptions, // used inside src/views/Index.js
  parseOptions, // used inside src/views/Index.js
  chartExample1, // used inside src/views/Index.js
};
